import { render, staticRenderFns } from "./SalesRecordsTab.vue?vue&type=template&id=2a49f81c&"
import script from "./SalesRecordsTab.vue?vue&type=script&lang=js&"
export * from "./SalesRecordsTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecordsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports